export const SET_DAILY_CRON_LOGS = 'SET_DAILY_CRON_LOGS';
